import { Component, OnInit, signal, Signal, WritableSignal, Output, EventEmitter, Input } from '@angular/core';
import { CompaniesComponent } from "../companies/companies.component";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfigInput, ConfigSelected } from '../../interfaces/interfaces';
import { ListsService } from '../../services/lists.service';
import { InputComponent } from "../input/input.component";
import { ProfessionComponent } from "../profession/profession.component";
import { SelectedComponent } from "../selected/selected.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-associated',
  imports: [
    CompaniesComponent,
    InputComponent,
    ReactiveFormsModule,
    ProfessionComponent,
    SelectedComponent,
    CommonModule
  ],
  templateUrl: './associated.component.html',
  styleUrl: './associated.component.css'
})
export class AssociatedComponent implements OnInit {

  form: FormGroup;
  dataInputs: WritableSignal<ConfigInput[]> = signal([
    { label: '¿Desde cuando trabajas en esa empresa?', subLabel: '', formName: 'since', placeholder: '', type: 'date', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona una fecha válida' },
    { label: 'Si tienes código de empleado por favor digitalo', subLabel: '', formName: 'code', placeholder: '', type: 'string', defaultValue: '', enabled: true, validation: null, textError: '' },
    { label: '¿Cuál es tu ingreso por la actividad económica principal?', subLabel: '', formName: 'income', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor ingresa un valor válido' },
    { label: 'Otros Ingresos', subLabel: '', formName: 'incomeExtraActivity', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [], textError: 'Por favor ingresa un valor válido' },
  ]);

  dataSelected: WritableSignal<ConfigSelected[]> = signal([
    { label: '¿Cuál es tu nivel educativo?', subLabel: '', formName: 'academic', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un nivel educativo', options: signal([]) },
    { label: '¿Perteneces a algún grupo de protección especial constitucional?', subLabel: '', formName: 'specialProtecionProgram', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor seleccione un elemento de la lista', options: signal([]) },
  ])

  @Output() formValid = new EventEmitter<any>();
  @Input() defaultData: any;

  constructor(
    private _listService: ListsService,
  ) {
    this.form = new FormGroup({
      since: new FormControl(null, [Validators.required]),
      code: new FormControl(null),
      codpro: new FormControl(null, [Validators.required]),
      academic: new FormControl(null, [Validators.required]),
      company: new FormControl(null, [Validators.required]),
      specialProtecionProgram: new FormControl(null, [Validators.required]),
      income: new FormControl(null, [Validators.required]),
      incomeExtraActivity: new FormControl(null, [Validators.required]),
    });

    this.form.valueChanges.subscribe(() => {
        this.formValid.emit(this.form.value);
    });
  }

  ngOnInit(): void {
    this.getAllAcademicLevels();
    this.getAllSpecialProgram();

    if (this.defaultData) {
      this.dataInputs.update((inputs:any) =>
        inputs.map((input:any) => ({
          ...input,
          defaultValue: this.defaultData[input.formName] ?? input.defaultValue
        }))
      );    
      this.dataSelected.update((inputs:any) =>
        inputs.map((input:any) => ({
          ...input,
          defaultValue: this.defaultData[input.formName] ?? input.defaultValue
        }))
      );
    }
  }

  getAllSpecialProgram() {
    this._listService.getAllSpecialProgram().subscribe({
      next: (response: any) => {
        this.dataSelected().at(1)?.options.set(response);
      },
      error: (error: any) => {
        console.error('Error loading special programs:', error);
      }
    });
  }

  getAllAcademicLevels() {
    this._listService.getAllAcademicLevels().subscribe({
      next: (response: any) => {
        this.dataSelected().at(0)?.options.set(response);
      },
      error: (error: any) => {
        console.error('Error loading academic levels:', error);
      }
    });
  }

  setCompany(companyId: string | number | null) {
    this.form.get('company')!.setValue(companyId);
  }

  onProfessionSelected(selectedOption: any): void {
    this.form.get('codpro')!.setValue(selectedOption);
  }

  handleValue(event: { formName: string, value: string | number }) {
    this.form.get(event.formName)?.setValue(event.value);
  }
}